import { useAuthentication } from './useAuthentication'

export default useAuthentication
